/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.chevron-double-left\":[\"Dobbel pil til venstre\"]}");